import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import IConnectToTeam from '../model/IConnectToTeam';
import { distinctBy } from '../utils/arrayUtils';

export interface ReportingTeamItem {
    id: string;
    name: string;
}

const useReportingTeamItems = (
    allTeams: IConnectToTeam[],
    allTeamsLabelKey = 'Reporting_AllTeams'
) => {
    const { t } = useTranslation();

    const allTeamsOption: ReportingTeamItem = useMemo(
        () => ({
            id: '_all',
            name: t(allTeamsLabelKey),
        }),
        [allTeamsLabelKey, t]
    );

    const uniqueTeams: ReportingTeamItem[] = useMemo(
        () => [
            allTeamsOption,
            ...distinctBy(allTeams, (x) => x.teamId).map((x) => ({
                id: x.teamId,
                name: x.teamName,
            })),
        ],
        [allTeamsOption, allTeams]
    );

    return { teams: uniqueTeams, allTeamsOption: allTeamsOption };
};

export default useReportingTeamItems;
